import ListingPortfolioCard from './ListingPortfolioCard.component';

export default ListingPortfolioCard;
